"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FotoPerfilUsuario } from "./AvatarComFoto";
import { useExperienciaProduto } from "./ExperienciaProvider";
import { Menu, MenuItem } from "./Menu";
import { PopupMeta } from "./PopupMeta";
import { PopupNumeros } from "./PopupNumeros";
import { PopupConfiguracoes } from "./PopupConfiguracoes";
import { PopupPerfil } from "./PopupPerfil";
import { PopupTema } from "./PopupTema";
import { SairButton } from "./SairButton";
import { contextosMetaMenuPerfil, podeMostrarNumerosMenuPerfil } from "@/lib/followzap-navigation";
import { podeUsarLocalidade } from "@/lib/localidades-brasil";

export function MenuPerfil() {
  const { dados, experiencia } = useExperienciaProduto();
  const [aberto, setAberto] = useState(false);
  const [perfilAberto, setPerfilAberto] = useState(false);
  const [temaAberto, setTemaAberto] = useState(false);
  const [metaAberta, setMetaAberta] = useState(false);
  const [numerosAbertos, setNumerosAbertos] = useState(false);
  const [configuracoesAbertas, setConfiguracoesAbertas] = useState(false);
  const mostrarConfiguracoes = podeUsarLocalidade(dados?.produto, dados?.papel);
  const contextosMeta = contextosMetaMenuPerfil(dados?.produto, dados?.papel, experiencia.recursos.configuracoes);
  const mostrarNumeros = podeMostrarNumerosMenuPerfil(dados?.produto, dados?.papel, experiencia.recursos.numerosOperacionais);

  return (
    <>
      <Menu
        open={aberto}
        onOpenChange={setAberto}
        ariaLabel="Menu do perfil"
        contentClassName="absolute right-0 top-full z-[80] mt-2 w-48"
        trigger={(props) => (
          <button
            {...props}
            type="button"
            aria-label="Abrir menu do perfil"
            title="Menu do perfil"
            className="flex h-11 items-center gap-1.5 rounded-xl border border-[var(--fz-header-border)] px-1.5 text-[var(--fz-header-text)] transition-colors hover:bg-[var(--fz-floating-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fz-floating-focus-ring)]"
          >
            <FotoPerfilUsuario className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--fz-floating-hover)] text-xs font-semibold text-[var(--fz-header-text)]">
              {dados?.marca.sigla ?? "US"}
            </FotoPerfilUsuario>
            <ChevronDown aria-hidden="true" className="h-4 w-4" />
          </button>
        )}
      >
        <MenuItem onSelect={() => setPerfilAberto(true)} className="px-3 py-2 text-sm">
          Perfil
        </MenuItem>
        <MenuItem onSelect={() => setTemaAberto(true)} className="px-3 py-2 text-sm">
          Tema
        </MenuItem>
        {contextosMeta.length > 0 ? (
          <MenuItem onSelect={() => setMetaAberta(true)} className="px-3 py-2 text-sm">
            Meta
          </MenuItem>
        ) : null}
        {mostrarNumeros ? (
          <MenuItem onSelect={() => setNumerosAbertos(true)} className="px-3 py-2 text-sm">
            Números
          </MenuItem>
        ) : null}
        {mostrarConfiguracoes ? (
          <MenuItem onSelect={() => setConfiguracoesAbertas(true)} className="px-3 py-2 text-sm">
            Configurações
          </MenuItem>
        ) : null}
        <SairButton variant="menu" />
      </Menu>
      {perfilAberto ? <PopupPerfil onClose={() => setPerfilAberto(false)} /> : null}
      {temaAberto ? <PopupTema onClose={() => setTemaAberto(false)} /> : null}
      {metaAberta && contextosMeta.length > 0 ? <PopupMeta contextos={contextosMeta} onClose={() => setMetaAberta(false)} /> : null}
      {numerosAbertos && mostrarNumeros ? <PopupNumeros followPro={dados?.produto === "FOLLOW_PRO"} onClose={() => setNumerosAbertos(false)} /> : null}
      {configuracoesAbertas && mostrarConfiguracoes ? <PopupConfiguracoes onClose={() => setConfiguracoesAbertas(false)} /> : null}
    </>
  );
}
